async function jqueryImport() {
  const { default: jQuery } = await import('jquery');
  window.jQuery = jQuery;
  window.$ = jQuery;
}
setTimeout(jqueryImport, 0);
